<template>
	<section class="main-content intro">
		<div class="row">
			<slot>
				<div :class="introText ? 'column6' : 'column12'" class="columns align-left">
					<h1 class="subtitle">{{ subtitle }}</h1>
					<h1>{{ title }}</h1>
				</div>
				<div class="columns column6 align-left">
					<slot name="extra-heading" />
					<div v-parse-links v-html="introText" />
					<slot name="extra-content" />
				</div>
				<br />
				<div class="columns column12 align-left">
					<slot name="extra-heading" />
					<div v-parse-links v-html="content" />
					<slot name="extra-content" />
				</div>
			</slot>
		</div>
	</section>
</template>

<script setup>
defineProps({
	title: { type: String, default: '' },
	subtitle: { type: String, default: '' },
	introText: { type: String, default: '' },
	content: { type: String, default: '' },
});
</script>

<style lang="scss" scoped>
h1 {
	line-height: 56px;
	max-width: 80%;
}

.subtitle {
	font-family: var(--body-font-family);
	font-weight: 300;
	font-size: 18px;
	text-transform: uppercase;
	letter-spacing: 5%;
}

.intro {
	svg {
		width: 100vw;
		height: 50vh;
	}

	background:
		url('~/assets/images/Group 19.png') left top no-repeat,
		url('~/assets/images/Group 20.png') right bottom no-repeat;
	background-color: var(--brown-lightest);

	.row {
		padding: 0 50px;
	}
}

@media (max-width: 1080px) {
	.intro {
		.row {
			padding: 0 20px;
		}
	}
}
</style>
